import { defineAction } from '~/prix'
import { z } from 'zod'
import creditBracketFetchAction from './creditBracketFetch.action.json' with { type: 'json' }
import { creditBracketObject } from '../creditBracketObject'

const creditBracketFetchDefinition = defineAction({
  ...creditBracketFetchAction,

  input: z.object({
    id: creditBracketObject.shape.id,
    includeDeleted: z.boolean().nullish(),
  }),
  output: creditBracketObject,
})

export default creditBracketFetchDefinition

